import React from 'react';
import './default-error-boundary.css';
import { pushRedirectMetaCallback } from '../../meta-tags/prerender-redirect-meta';
import { signalPrerenderReady } from 'utility/utility';

export class DefaultErrorBoundary extends React.Component {
  prerenderDoneTimeout = null;

  prerenderDone = false;

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    pushRedirectMetaCallback(undefined, 500);
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught in DefaultErrorBoundary:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    if (!this.prerenderDoneTimeout && this.prerenderDone) {
      this.prerenderDoneTimeout = setTimeout(() => {
        this.prerenderDone = true;
        signalPrerenderReady();
      }, 1000);
    }

    return (
      <div className="boundary-page">
        <div className="boundary-card">
          <header className="header">
            <SmileyXEyes className={'boundary-x-icon'} />
            <h1 className="title">Something unexpected went wrong</h1>
          </header>
          <main>
            <div className="apology">
              <h2 className="subtitle">We are sorry for the inconvenience</h2>
              <p className="description">Please try again later or contact us if the problem persists.</p>
            </div>
            <div className="hide-error">
              <h3 className="message">{this.state.error?.message}</h3>
              <div className="stack">
                {this.state.error?.stack?.split('\n').map((line, index) => (
                  <div key={index} className="stack-line">
                    {line}
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

function SmileyXEyes({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className={className}>
      <rect width="256" height="256" fill="none" />
      <circle cx="128" cy="128" r="96" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="16" />
      <line
        x1="184"
        y1="96"
        x2="152"
        y2="128"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <line
        x1="184"
        y1="128"
        x2="152"
        y2="96"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <line
        x1="104"
        y1="96"
        x2="72"
        y2="128"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <line
        x1="104"
        y1="128"
        x2="72"
        y2="96"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <circle cx="128" cy="180" r="12" />
    </svg>
  );
}
